import { gql } from '@apollo/client';

/**
 * GraphQL query for fetching community details specifically for moderation pages
 *
 * This query fetches only the fields needed by moderation pages: identity, display,
 * and moderationStats. This avoids polling the full GET_COMMUNITY query (which
 * includes actions, workflowConfigurations, optionalMetadata, securityGroups, etc.)
 * every 30 seconds just to refresh moderation statistics.
 */
export const GET_COMMUNITY_FOR_MODERATION = gql`
  query GetCommunityForModeration($id: ID!) {
    community(id: $id) {
      id
      name
      communityGroupId
      logoUrl
      superHeroArtUrl
      moderationStats {
        topicName
        communityId
        openCasesCount
        assignedCasesCount
        inSLACases
        nearSLACases
        outOfSLACases
      }
    }
  }
`;
